var exports = {
  "Q": "solid__s_S3Cr",
};

module.exports = exports;
